import React from "react";
import * as cx from "classnames";
import { Link } from "react-router-dom";
import ReportDates from "./ReportDates";
import DesktopIcon from "../Desktop.svg";
import MobileIcon from "../Mobile.svg";
import ScreenshotItem from "./ScreenshotItem";
import { reportLookup, moduleLookup, capitalize, formatDate } from "../util";

const dwwUrl = "https://dowhatworks.io";
const allDraft = "8856d019-8c3e-489d-b0aa-32bd0923c6a0";

const qDisplay = {
  approval_review: "Approval Queue",
  publish_review: "Publishing Queue",
  analyst_review: "Feedback Queue",
  draft_hold: "Hold Queue",
  draft_review: "Draft Queue",
};

class ReportItemDisplay extends React.Component {
  state = {
    show: false,
    name: undefined,
    id:
      this.props.savedTests && this.props.savedTests.length > 0
        ? this.props.savedTests[0].id
        : undefined,
    savedTests: this.props.savedTests || [],
    addedTests: this.props.d.savedTests || [],
    showAllCollections: false,
  };
  showAllCollections = e => {
    e.preventDefault();
    this.setState({ showAllCollections: true });
  };
  render() {
    const { d, userCompany, urlCompany, byModule, isAdminPage, i } = this.props;

    const testsDisplay = [];

    testsDisplay.sort((a, b) => (a.isFav ? 1 : -1));

    return (
      <div
        className={cx({
          "test-box": i % 2 === 0,
          "test-box-odd": i % 2 !== 0,
        })}
      >
        <div
          className={cx({
            "db near-black block-link document-spacing center": true,
            pb1: isAdminPage,
            pb4: !isAdminPage,
          })}
        >
          <div className="f5 mb3 near-black bb b--divider item-header">
            <a
              href={`${dwwUrl}/home/${urlCompany}/screenshots/${d.id}${
                byModule ? "?fromModule=true" : ""
              }`}
              className="ui-link"
            >
              <span className="">
                {d.headline_tag ? capitalize(d.headline_tag) : "NO HEADLINE"}{" "}
              </span>
            </a>
            {d.report === allDraft ? (
              <span>
                ({d.q_status ? qDisplay[d.q_status] : qDisplay["draft_review"]})
              </span>
            ) : (
              <span>(Published)</span>
            )}{" "}
            {userCompany === "admin" && (
              <a
                href={`${dwwUrl}/admin/screenshots/edit/${d.id}?back=${window.location.href}`}
                className="ttu ml2 f8 b edit-link"
              >
                Edit
              </a>
            )}
            <div className="f4">
              <ReportDates start_date={d.start_date} end_date={d.end_date} />
            </div>
          </div>
          <div
            className={cx({
              "ph3 pb3 flex ss-container-parent": true,
              has2: d.screenshots.length <= 2,
            })}
          >
            <div className="screenshot-container">
              <ScreenshotItem
                userCompany={userCompany}
                screenshots={d.screenshots}
                id={d.id}
                type={d.type}
                isAdminPage={isAdminPage}
                url={`${dwwUrl}/home/${urlCompany}/screenshots/${d.id}${
                  byModule ? "?fromModule=true" : ""
                }`}
                company={urlCompany}
              />
            </div>
          </div>
          {isAdminPage && (
            <div className="f6 mv2 db ba b--blue pa2 br3">
              <div>{d.isMobile ? <b>Mobile</b> : <b>Desktop</b>}</div>
              <div>
                <b>Challenge: </b> {moduleLookup[d.module_name]}
              </div>
              <div>
                <b>Page type: </b> {d.page_type}
              </div>
              <div>
                <div className="mb2">
                  <b>Notes:</b>
                </div>
                {d.notes && <div className="mb2">{d.notes}</div>}
                {d.notes_v2 && (
                  <>
                    {d.notes_v2.map(note => (
                      <div className="mb2">
                        {note.note} {note.user ? ` - ${note.user.name}` : ""}{" "}
                        {note.mtime ? formatDate(note.mtime) : ""}
                      </div>
                    ))}
                  </>
                )}
              </div>
              <div>
                <a href={d.url} target="_blank">
                  {d.url}
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ReportItemDisplay;
